

export interface ICompanyState {
        getAllcompanies: any;
        createError: any;
        createSuccess: any;
        getAllcompaniesError: any;
        editCompanySuccess: any;
        editCompanyError: any;
        convertToActiveSuccess: any;
        convertToActiveError: any;
        renewLicenseDateSuccess: any;
        renewLicenseDateError: any;
        giveExtensionDateSuccess: any;
        giveExtensionDateError: any;
        getCompanyByIdSuccess : any;
        getCompanyByIdError : any;
        getInactivateCmpySuccess: any;
        getActivateCmpyError: any;
        getActivateCmpySuccess: any;
        getInactivateCmpyError: any;
        getCompanyLicenseSuccess : any;
        getCompanyLicenseError : any;
        getUsersCountSuccess : any;
        getUsersCountError : any;
        getAllUsersSuccess : any;
        getAllUsersError : any;

        // allCompany: any;
        // admindetails: any;
    }
    export const initialCompanyState: ICompanyState = {
        getAllcompanies: null,
        createError: null,
        createSuccess: null,
        getAllcompaniesError: null,
        editCompanySuccess: null,
        editCompanyError: null,
        convertToActiveSuccess: null,
        convertToActiveError: null,
        renewLicenseDateSuccess: null,
        renewLicenseDateError: null,
        giveExtensionDateSuccess: null,
        giveExtensionDateError: null,
        getCompanyByIdSuccess : null,
        getCompanyByIdError : null,
        getInactivateCmpySuccess:null,
        getInactivateCmpyError:null,
        getCompanyLicenseSuccess : null,
        getCompanyLicenseError : null,
        getActivateCmpyError: null,
        getActivateCmpySuccess: null,
        getUsersCountSuccess : null,
        getUsersCountError : null,
        getAllUsersSuccess : null,
        getAllUsersError : null,

    };